import { render, staticRenderFns } from "./EditDialogLight.vue?vue&type=template&id=1f7bec5c&"
import script from "./EditDialogLight.vue?vue&type=script&lang=ts&"
export * from "./EditDialogLight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports